import script from "./DocExportLimit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocExportLimit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__